// extracted by mini-css-extract-plugin
module.exports = {"links":"FooterNav_links__M-uDH","current":"FooterNav_current__15Q38"};